import { render, staticRenderFns } from "./EventScroll.vue?vue&type=template&id=09ed0d81&"
import script from "./EventScroll.vue?vue&type=script&lang=ts&"
export * from "./EventScroll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports